import { DialogProps } from '@radix-ui/react-dialog'
import { useTranslation } from 'react-i18next'

import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog'

type Props = {
  cancelText?: string
  confirmText?: string
  description?: string
  onConfirm(): void
  title?: string
  variant?: 'destructive' | 'default'
} & DialogProps

export const ConfirmDialog = ({
  cancelText,
  confirmText,
  description,
  onConfirm,
  title,
  variant = 'default',
  ...props
}: Props) => {
  const { t } = useTranslation()

  return (
    <Dialog {...props}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{title ?? t('confirmDialog.title', { context: variant })}</DialogTitle>
          <DialogDescription>
            {description ?? t('confirmDialog.description', { context: variant })}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <DialogClose asChild>
            <Button variant="outline">{cancelText ?? t('confirmDialog.cancelText')}</Button>
          </DialogClose>
          <DialogClose asChild>
            <Button onClick={onConfirm} variant="destructive">
              {confirmText ?? t('confirmDialog.confirmText', { context: variant })}
            </Button>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export const ConfirmDialogTrigger = DialogTrigger
